// extracted by mini-css-extract-plugin
module.exports = {"container-search-orders":"SearchOrders_container-search-orders__eZF50","image-style":"SearchOrders_image-style__ZkheA","container-banner":"SearchOrders_container-banner__Zs3t4"};